import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import styled from 'styled-components'
import { SvgIcon } from '@/common/components/SvgIcon'
import { smoothScroll } from '@/pc/components/SmoothScroll'

const PageTopButton = styled.div`
  background-color: rgba(51, 51, 51, 0.9);
  border-radius: 50%;
  bottom: 24px;
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: grid;
  font-size: 2.4rem;
  height: 64px;
  line-height: 1;
  opacity: 0;
  place-items: center;
  position: fixed;
  right: 32px;
  text-align: center;
  transition: 0.25s ease;
  transition-property: opacity, visibility;
  visibility: hidden;
  width: 64px;

  &.show {
    opacity: 1;
    transition-property: opacity;
    visibility: visible;
  }

  &:hover {
    opacity: 0.8;
  }
`

const PageTop: React.FC = () => {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const option = {
      rootMargin: `${window.screen.availHeight / 4}px 0px ${document.body.clientHeight}px`,
      threshold: 1
    }

    const callback = (entries: IntersectionObserverEntry[]) => {
      if (typeof entries[0] === 'undefined') return
      setIntersecting(!entries[0].isIntersecting)
    }

    const observer = new IntersectionObserver(callback, option)
    observer.observe(document.body)
  }, [])

  return (
    <>
      <PageTopButton
        className={isIntersecting ? 'show' : ''}
        onClick={() => {
          smoothScroll()
        }}
      >
        <SvgIcon name="chevron-up" width={44} height={38} className="text-white" />
      </PageTopButton>
    </>
  )
}

export function initPageTop() {
  const pagetop = document.getElementById('js-page-top')
  if (pagetop === null) return
  const root = createRoot(pagetop)
  root.render(<PageTop />)
}
